/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Payments_Action_FailedInputs */

const en_my_payments_action_failed = /** @type {(inputs: My_Payments_Action_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That did not work. Try again.`)
};

const pl_my_payments_action_failed = /** @type {(inputs: My_Payments_Action_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się. Spróbuj ponownie.`)
};

/**
* | output |
* | --- |
* | "That did not work. Try again." |
*
* @param {My_Payments_Action_FailedInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const my_payments_action_failed = /** @type {((inputs?: My_Payments_Action_FailedInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Payments_Action_FailedInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_my_payments_action_failed(inputs)
	return en_my_payments_action_failed(inputs)
});